import { render, staticRenderFns } from "./AsyncPython.vue?vue&type=template&id=2b93c5bc&scoped=true&"
import script from "./AsyncPython.vue?vue&type=script&lang=ts&"
export * from "./AsyncPython.vue?vue&type=script&lang=ts&"
import style0 from "./AsyncPython.vue?vue&type=style&index=0&id=2b93c5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93c5bc",
  null
  
)

export default component.exports